import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import {
    fetchEmailTracking,
    clearEmailTracking,
} from '../features/email-tracking/email-tracking.slice';

/**
 * Custom hook wrapping the emailTracking slice — loads the timeline for an
 * invoice and exposes state + actions to the modal. Mirrors the per-feature
 * hook convention (useInvoice, useInvoiceSearch).
 */
export const useEmailTracking = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { details, loading, error } = useSelector((state: RootState) => state.emailTracking);

    const loadTracking = (invoiceId: number) => dispatch(fetchEmailTracking(invoiceId));
    const clear = () => dispatch(clearEmailTracking());

    return { details, loading, error, loadTracking, clear };
};
